<template>
  <common-dialog ref="dialog" :title="title" width="400px" @closed="onClosed" in-dialog>
    <el-form>
      <el-form-item label="选择星期">
        <week-picker
          ref="weekPicker"
          select-disable
          :s-date="TermStart"
          :e-date="TermEnd"
          @change="onChange"
        />
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
import weekPicker from "@/components/common/weekPicker";

export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog, weekPicker },
  data() {
    return {
      api: require("@/api/ed/timetable").default,
      term_api: require("@/api/ed/term").default,
      params: {
        WeekStartDate: "",
        WeekEndDate: "",
      },
      title: "导出 课程表",
      TermStart: "",
      TermEnd: "",
    };
  },
  methods: {
    setDate(TermId) {
      this.term_api.info(TermId).then((res) => {
        if (res.Code == 0) {
          this.TermStart = this.$commonJs.toDateString(res.Data.StartTime);
          this.TermEnd = this.$commonJs.toDateString(res.Data.EndTime);
        }
        this.$refs.weekPicker.init();
      });
    },
    onChange(data) {
      this.params.WeekStartDate = data.start;
      this.params.WeekEndDate = data.end;
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.params = {};
    },
  },
};
</script>